var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/message-question"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M85 92.6502H65L42.7499 107.45C39.4499 109.65 35 107.3 35 103.3V92.6502C20 92.6502 10 82.6502 10 67.6502V37.6499C10 22.6499 20 12.6499 35 12.6499H85C100 12.6499 110 22.6499 110 37.6499V67.6502C110 82.6502 100 92.6502 85 92.6502Z",
    stroke: "#123EC9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.9991 57.2998V56.25C59.9991 52.85 62.0992 51.0499 64.1992 49.5999C66.2492 48.1999 68.299 46.4 68.299 43.1C68.299 38.5 64.5991 34.7998 59.9991 34.7998C55.3991 34.7998 51.6992 38.5 51.6992 43.1",
    stroke: "#123EC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M59.9775 69.25H60.0225",
    stroke: "#123EC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.9cab52b220a80f217e2edaa99a903992.svg";
export { ForwardRef as ReactComponent };